import { Link } from '@remix-run/react'
import { AppIcon } from './ui/icons/app-icon.tsx'

function BlockOfLinks({ children, title }: { children: any; title: string }) {
	return (
		<div className="flex flex-col gap-4">
			<span className="text-h6">{title}</span>

			<div className="flex flex-col gap-2">{children}</div>
		</div>
	)
}

export function Footer() {
	return (
		<footer className="block w-full pt-48" id="footer">
			<div className="container">
				<div className="flex flex-col gap-20 sm:flex-row">
					<div className="flex flex-col gap-1">
						<div className="flex flex-row items-center gap-2">
							<AppIcon className="h-10 w-10" />
							<b className="bg-app-gradient mt-1 bg-clip-text text-h6 text-transparent bg-blend-normal">
								SwapMyFace AI
							</b>
						</div>
						<div className="text-sm opacity-30">
							© Copyright {new Date().getFullYear()} All Rights <br />
							Reserved by Luisiacc LLC.
						</div>
					</div>
					<BlockOfLinks title="Pages">
						<Link prefetch="intent" to="/login" className="text-sm opacity-80">
							Login
						</Link>
						<a
							// eslint-disable-next-line remix-react-routes/use-link-for-routes
							href="mailto:support@swapmyface.app"
							className="text-sm opacity-80"
						>
							Contact support
						</a>
						<Link to="/blog" className="text-sm opacity-80">
							Blog
						</Link>
						<Link to="/chrome-extension" className="text-sm opacity-80">
							Chrome extension
						</Link>
						<Link to="/plans" className="text-sm opacity-80">
							Pricing
						</Link>
						<Link to="/#faqs" className="text-sm opacity-80">
							FAQ
						</Link>
					</BlockOfLinks>
					<BlockOfLinks title="How to use">
						<Link
							prefetch="intent"
							to="/articles/how-to-use-with-midjourney"
							className="text-sm opacity-80"
						>
							With Midjourney
						</Link>
						<Link
							prefetch="intent"
							to="/articles/how-to-use-with-leonardo"
							className="text-sm opacity-80"
						>
							With Leonardo AI
						</Link>
					</BlockOfLinks>
					<BlockOfLinks title="Legal">
						<Link to="/tos" className="text-sm opacity-80">
							Terms of Service
						</Link>
						<Link to="/privacy" className="text-sm opacity-80">
							Privacy Policy
						</Link>
					</BlockOfLinks>
					<BlockOfLinks title="Other">
						<a href="https://www.theinsaneapp.com/tools/swapmyface/" className="text-sm opacity-80">
							The Insane App
						</a>
					</BlockOfLinks>
				</div>
			</div>
			<div className="h-10" />
		</footer>
	)
}
